import { ReactElement, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Details } from '@digdir/designsystemet-react';
import { AssessedRisk, methodItems } from '../reportView';
import classes from '../WorkEnvironmentReport.module.css';

type Props = { risk: AssessedRisk; forPdf: boolean };

/** How to read the numbers, closed until asked for. The PDF has it open. */
export const MethodSection = ({ risk, forPdf }: Props): ReactElement => {
  const { t, i18n } = useTranslation();
  const [open, setOpen] = useState(false);
  return (
    <Details
      id="report-method"
      className={classes.methodDetails}
      open={forPdf || open}
      onToggle={(event) => setOpen((event.currentTarget as HTMLDetailsElement).open)}
    >
      <Details.Summary>{t('workEnvironmentReport.sections.method')}</Details.Summary>
      <Details.Content>
        <dl className={classes.method}>
          {methodItems(risk, t, i18n.language).map((item) => (
            <div key={item.key}>
              <dt className="ds-label" data-size="sm">
                {item.title}
              </dt>
              <dd className="ds-paragraph" data-size="sm">
                {item.text}
              </dd>
            </div>
          ))}
        </dl>
      </Details.Content>
    </Details>
  );
};
